import { VisibilityTypes } from '@src/api';
import { IntersectionType } from '@src/api/types';

export const visibilityDefaultValue = {
  laboratoryIntersectionType: IntersectionType.Exclude,
  laboratoryIds: [],
  facilityIntersectionType: IntersectionType.Exclude,
  facilityVisibilities: [],
  salesRepresentativeId: null,
};

export const visibilityWithNoneValue = {
  laboratoryIntersectionType: IntersectionType.None,
  laboratoryIds: [],
  facilityIntersectionType: IntersectionType.None,
  facilityVisibilities: [],
  salesRepresentativeId: null,
};
export const defaultValues = isEdit => ({
  name: '',
  referenceLink: '',
  internalDescription: '',
  patientDescription: '',
  criterias: [{}],
  visibilityType: VisibilityTypes.ForMe,
  createVisibility: isEdit ? null : visibilityDefaultValue,
});
